module.exports = __webpack_public_path__ + "img/2.ee33d3d5.gif";